import React from 'react'
import CommonLayout from '../../../../Components/CommonLayout/CommonLayout'
import BasicTable from '../../../../Components/CommonTable/BasicTable/BasicTable'
import { TiStarOutline } from 'react-icons/ti';
import ReviewCard from './ReviewCard';


function  Review() {

    const columns = [
        { field: 'order', header: 'Order' },
        { field: 'user', header: 'User' },
        { field: 'store', header: 'Store' },
        { field: 'deliveryBoy', header: 'Delivery Boy' },
        { field: 'toStore', header: 'To Store' },
        { field: 'toDeliveryBoy', header: 'To Delivery Boy' },
        { field: 'type', header: 'Type' },
        { field: 'completed', header: 'Completed' },
      ];
      
      const data = [
        {
          order: '1000',
          user: 'John Doe',
          store: 'Supermart',
          deliveryBoy: 'James Smith',
          toStore: 'Main Warehouse',
          toDeliveryBoy: 'James Smith',
          type: 'Home Delivery',
          completed: 'Yes',
        },
        {
          order: '1001',
          user: 'Jane Doe',
          store: 'Electronics Hub',
          deliveryBoy: 'N/A',
          toStore: 'Electronics Warehouse',
          toDeliveryBoy: 'N/A',
          type: 'Pick Up',
          completed: 'Yes',
        },
        // Add more records as needed
      ];
      
      
    
    
    const searchBy={
      filterType:"Search By",
      inputName:"search_by",
      options:[
        {
          name:"User",
          code:"User",
        },
        {
          name:"Delivery Man",
          code:"Delivery Man",
        },
        {
          name:"Store",
          code:"Store",
        },
        {
          name:"Order",
          code:"Order",
        },
      ]
    }
    
    const filters=[
      {
        filterType:"Order Status",
        inputName:"Order_Status",
        options:[
          {
            name:"Completed",
            code:"Completed",
          },
          {
            name:"Rejected",
            code:"Rejected",
          },
          {
            name:"Cancelled",
            code:"Cancelled",
          },
        ]
      }, 
      {
        filterType:"delivery Type",
        inputName:"delivery_type",
        options:[
          {
            name:"Table Booking",
            code:"Table Booking",
          },
          {
            name:"Store",
            code:"Store",
          },
          {
            name:"Courier",
            code:"Courier",
          },
        ]
      },
        
    ]
    
     
    
      return (
        <div className='main-content'>
            {/* <CommonLayout/> */}
            <div className="d-flex gap-1 my-2">
                <ReviewCard title="Order Review" ratingCount="0 / 0" />
                <ReviewCard title="Delivery Review" ratingCount="0 / 0" />
            </div>
            <BasicTable
             data={data} 
             columns={columns}
             SearchBy={searchBy}
             filters={filters}
             WeekRange={true}
             MonthRange={true}         
             />
        </div>
    )
}

export default Review

